import { createStore } from "@stencil/store";

const { state, onChange } = createStore({
    navHeight: 0,
    navHeightForButton: 0,
    navbarMode: 'gradient',
    requireLabelPadding: false,
});

onChange('navbarMode', value => {
    state.navbarMode = value;
})

onChange('navHeight', value => {
    state.navHeight = value;
});

onChange('navHeightForButton', value => {
    state.navHeightForButton = value;
})

onChange('requireLabelPadding', value => {
    state.requireLabelPadding = value;
})

export default state;